module.exports = __webpack_public_path__ + "img/gallery-image-12.1ae6d394.jpg";